import { motion } from "framer-motion";
import { ShieldCheck, Zap, Cpu, Radar } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";
import { CERTS } from "@/content/site";

const ICONS = { licensed: ShieldCheck, tesla: Zap, enphase: Cpu, solaredge: Radar };

export const Credentials = () => (
  <section data-testid="credentials-section" className="relative bg-[#08090a] py-24 sm:py-32">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
        <SectionHead className="lg:col-span-7" index="01" eyebrow="Credentials" lines={["Certified. Qualified.", "Built to last."]} />
        <p className="lg:col-span-5 text-base md:text-lg text-zinc-300 leading-relaxed">
          Every project is handled by a licensed and insured team with manufacturer certifications across the equipment Texas homeowners rely on most.
        </p>
      </div>
      <div className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {CERTS.map((c, i) => {
          const Icon = ICONS[c.key];
          return (
            <motion.article
              key={c.key} data-testid={`cert-card-${c.key}`}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.9, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -6 }}
              className="card-lux group relative overflow-hidden rounded-2xl p-7 sm:p-8"
            >
              <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-amber-500/0 blur-3xl transition-colors duration-700 group-hover:bg-amber-500/25" />
              <div className="flex items-start justify-between">
                <div className="relative grid h-14 w-14 place-items-center rounded-full border border-amber-400/40 bg-gradient-to-b from-amber-400/15 to-transparent">
                  <Icon className="h-6 w-6 text-amber-400" />
                  <svg viewBox="0 0 60 60" className="absolute -inset-2 h-[calc(100%+16px)] w-[calc(100%+16px)] spin-slow" aria-hidden="true">
                    <circle cx="30" cy="30" r="28" fill="none" stroke="rgba(209,213,219,0.3)" strokeDasharray="1 5" />
                  </svg>
                </div>
                <span className="font-mono text-xs text-zinc-500">0{i + 1}</span>
              </div>
              <h3 className="mt-10 text-lg font-semibold uppercase tracking-tight text-white">{c.title}</h3>
              <div className="mt-4 h-px w-10 bg-amber-400/70 transition-[width] duration-700 group-hover:w-20" />
              <p className="mt-4 text-sm leading-relaxed text-zinc-300">{c.text}</p>
              <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.24em] text-zinc-400">Verified Credential</p>
            </motion.article>
          );
        })}
      </div>
    </div>
  </section>
);
